// extracted by mini-css-extract-plugin
export default {"root":"xBUmRiqSRBpM_vsv18TO","tabulateButton":"lzOOUICQw5ZC4wIdWSv_"};